<template>
  <div class="select-search-type">
    <radio-button
      id="search-type-entire-site"
      class="select-search-type__option"
      checked
      name="searchType"
      value="entire site"
      @input="handleInput"
    >Search entire site</radio-button>
    <radio-button
      id="search-type-condition"
      class="select-search-type__option"
      name="searchType"
      value="condition"
      @input="handleInput"
    >Search your condition</radio-button>
  </div>
</template>

<script>
import RadioButton from '@/components/Inputs/RadioButton.vue';

export default {
  name: 'SelectSearchType',
  components: {
    RadioButton,
  },
  data() {
    return {
      searchType: 'entire site',
    };
  },
  computed: {},
  methods: {
    handleInput(event) {
      this.searchType = event.value;
      this.$emit('changed', this.searchType);
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/stylesheets/components/_select-search-type';
</style>
